import { TDatabaseId } from '@infotech-soe/metaschema';
import { useState } from 'react';

import { ContextMenuParams } from '../../hooks/useContextMenu';
import { getCoordsFromElementOrEvent } from '../../utils/getCoordsFromElementOrEvent';

export interface TreeContextMenuParams extends ContextMenuParams {
  selectNode: (id: TDatabaseId) => void;
}

export const useTreeContextMenu = (params: TreeContextMenuParams) => {
  const [positionX, setPositionX] = useState(params.x ?? 0);
  const [positionY, setPositionY] = useState(params.y ?? 0);
  const [isOpen, setOpen] = useState(params.open ?? false);

  const onContextMenu = (event: React.MouseEvent | KeyboardEvent) => {
    const parent = (event.target as HTMLElement).parentElement;
    const target =
      // TODO: get rid of classes usage cause it can broke logic implicitly
      parent?.querySelector<HTMLElement>('[data-tree-node-id].isActive') ??
      parent?.querySelectorAll<HTMLElement>('[data-tree-node-id]')?.[0];

    if (!target) {
      return;
    }

    const nodeId = target.dataset.treeNodeId;
    if (nodeId) params.selectNode(Number(nodeId));

    const { x, y } = getCoordsFromElementOrEvent(
      event as React.MouseEvent,
      target
    );
    setPositionX(x);
    setPositionY(y);
    setOpen(true);
  };

  return { isOpen, positionX, positionY, onContextMenu, setOpen };
};
